import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TicketApiService } from 'src/app/services/api/ticket-api.service';
import { AccountSupportModalComponent } from '../account-support-modal/account-support-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-support1-panel',
  templateUrl: './support1-panel.component.html',
  styleUrls: ['./support1-panel.component.scss'],
})
export class Support1PanelComponent implements OnInit, OnChanges {
  @Output() next = new EventEmitter<any>();

  /** 新手教程演示数据：提供时列表直接展示假数据，不请求真实车票 */
  @Input() demoData: any[] | null = null;

  constructor(
    private api: TicketApiService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    if (this.demoData) {
      this.loading = false;
      this.seats = this.demoData;
      return;
    }
    this.findBusSeats(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['demoData'] || changes['demoData'].firstChange) {
      return;
    }
    // 教程开始：切到假数据；教程结束：恢复真实车票
    if (this.demoData) {
      this.loading = false;
      this.seats = this.demoData;
    } else {
      this.findBusSeats(true);
    }
  }

  filterOrders(value: string) {
    this.findBusSeats(false);
  }

  select(info: any) {
    if (info.workorders.length > 0) {
      this.checkInfo(info);
      return;
    }
    this.next.emit(info);
  }

  loading = false;
  seats: any = [];
  query = '';
  async findBusSeats(showLoading: boolean) {
    if (this.demoData) {
      this.loading = false;
      this.seats = this.demoData;
      return;
    }
    try {
      if (showLoading) {
        this.loading = true;
      }
      const r = await this.api.findSeatTicket(this.query);
      this.seats = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  checkInfo(info: any) {
    this.dialog
      .open(AccountSupportModalComponent, {
        data: info,
        width: '480px',
        panelClass: 'app-dialog',
      })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.next.emit(info);
        }
      });
  }
}
